var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.href ? 'a' : 'span',_vm._b({tag:"component",staticClass:"a-button",class:[
    {
      'a-button--small': _vm.small,
      'a-button--large': _vm.large,
      'a-button--primary': _vm.primary,
      'a-button--blue': _vm.blue,
      'a-button--black': _vm.black,
      'a-button--success': _vm.success,
      'a-button--ghost': _vm.ghost,
      'a-button--outlined': _vm.outlined,
      'a-button--disabled': _vm.disabled,
      'a-button--loading': _vm.loading,
      'a-button--fullWidth': _vm.fullWidth,
    },
    _vm.cssClass ],attrs:{"href":_vm.href.length ? _vm.href : false,"disabled":_vm.disabled},on:{"click":_vm.clickHandler}},'component',{},false),[(_vm.loading)?_c('span',{staticClass:"\n      tw-absolute tw-z-10 tw-inset-0 tw-flex tw-items-center tw-justify-center\n    "},[_c('a-icon',{staticClass:"tw-animate-spin tw-w-5 tw-h-5",attrs:{"value":_vm.mdiLoading}})],1):_vm._e(),_c('span',{staticClass:"tw-flex tw-justify-center tw-items-center",class:{ 'tw-opacity-40': _vm.loading }},[(_vm.$slots.default)?[_vm._t("default")]:[_vm._v(" "+_vm._s(_vm.label)+" ")]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }